function initProductTabs(root) {
  if (!root) return;

  const buttons = Array.from(root.querySelectorAll('[data-tab-button]'));
  const panels = Array.from(root.querySelectorAll('[data-tab-panel]'));

  if (!buttons.length || !panels.length) return;

  function activate(index) {
    buttons.forEach((btn, i) => {
      btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
    panels.forEach((panel, i) => {
      if (i === index) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  buttons.forEach((btn, i) => {
    btn.addEventListener('click', () => activate(i));
  });

  activate(0);
}

function initAllProductTabs() {
  document.querySelectorAll('[data-product-tabs]').forEach(initProductTabs);
}

document.addEventListener('DOMContentLoaded', initAllProductTabs);

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-product-tabs]');
  if (root) initProductTabs(root);
});